import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import ProgrammingBoard from "@/components/ProgrammingBoard.vue";
import { Order_By } from "@/generated/graphql";
import StringUtils from "@/utils/stringUtils";
import { Watch } from "vue-property-decorator";
import { addWeeks, getISOWeek, getISOYear, subWeeks } from "date-fns";
import ProgressButton from "@/components/ProgressButton.vue";
import * as _ from "lodash";
import trainingService from "@/services/trainingService";
import Formatter from "../utils/formatter";
class TrainingData {
    constructor(id, 
    // public trainingDay: number,
    // public trainingWeek: Week,
    day, week, year, content, extra_strength, extra_gym, extra_aerobic, extra_double, board) {
        this.id = id;
        this.day = day;
        this.week = week;
        this.year = year;
        this.content = content;
        this.extra_strength = extra_strength;
        this.extra_gym = extra_gym;
        this.extra_aerobic = extra_aerobic;
        this.extra_double = extra_double;
        this.board = board;
    }
}
var Week;
(function (Week) {
    Week["previous"] = "previous";
    Week["current"] = "current";
    Week["next"] = "next";
})(Week || (Week = {}));
let Programming = class Programming extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.trainings = new Array();
        this.trainingsTask = Task.idle();
        this.boardsTask = Task.idle();
        this.trainingsQueries = new Map();
        this.trainingsPerRows = new Array();
        this.day = -1;
        this.week = Week.current;
        this.unsavedChanges = false;
        this.submitTask = Task.idle();
        this.copyFromHistoryTask = Task.idle();
        this.weeksFromHistory = [];
        this.weekFromHistory = null;
        // private dateInRange(date: Date, startDate: Date, endDate: Date): boolean {
        //   // return isAfter(it.date, this.startDate) || isEqual(it.date, this.startDate) || isEqual(it.date, this.endDate) || isBefore(it.date, this.endDate)
        //   return isWithinRange(date, startDate, endDate)
        // }
    }
    created() {
        window.addEventListener("beforeunload", this.beforeUnload);
        this.fetchBoards();
        this.fetchHistoryList();
    }
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeUnload);
    }
    beforeUnload(e) {
        if (this.unsavedChanges) {
            e.preventDefault();
            e.returnValue = "";
        }
    }
    beforeRouteLeave(to, from, next) {
        if (this.unsavedChanges) {
            const confirm = window.confirm("Exit page? Changes you made may not be saved.");
            if (!confirm) {
                next(false);
                return;
            }
        }
        next();
    }
    onUpdateQuery() {
        let week = null;
        if (this.$route.query.week != null) {
            week = Week[this.$route.query.week.toString()];
        }
        this.week = week != null ? week : Week.current;
        console.log(`CHANGED WEEK: ${this.week}`);
        let date = new Date();
        // let date = new Date(getYear(now), getMonth(now), getDate(now), 0, 0, 0, 0)
        switch (this.week) {
            case Week.previous:
                date = subWeeks(date, 1);
                break;
            case Week.next:
                date = addWeeks(date, 1);
                break;
        }
        let day = null;
        if (this.$route.query.day != null) {
            day = Number(this.$route.query.day);
        }
        this.day =
            day != null && Number.isInteger(day) && day >= 1 && day <= 7 ? day : 1;
        this.currentWeek = getISOWeek(date);
        this.currentYear = getISOYear(date);
        // this.startDate = startOfWeek(date, {weekStartsOn: 1})
        // this.endDate = endOfWeek(date, {weekStartsOn: 1})
        this.fetchTrainings();
    }
    onUpdateContent() {
        this.unsavedChanges = true;
        this.submitTask = this.submitTask.resetIfFinished;
    }
    copyTrainingContent(training) {
        if (StringUtils.isBlank(training.content)) {
            return;
        }
        const weekTrainings = this.trainings.filter(it => it.year == training.year &&
            it.week == training.week &&
            it.day == training.day);
        if (weekTrainings.length == 0) {
            return;
        }
        const lowerBoard = weekTrainings.find(it => it.board.level == training.board.level - 1);
        if (lowerBoard == undefined) {
            return;
        }
        lowerBoard.content = training.content;
    }
    escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }
    createContent(training) {
        let content = training.content;
        const extras = Array();
        const data = {};
        Formatter.trainingExtras.forEach(it => {
            // Make sure all extras are provided in the input, in order to be able to remove a previously provided extra
            data[`extra_${it}`] = "";
            const tag = Formatter.formatTrainingExtraTag(it);
            const tagRegExp = this.escapeRegExp(tag);
            const regEx = new RegExp(tagRegExp, "ig");
            content = content.replace(regEx, tag);
            const index = content.indexOf(tag);
            if (index != -1) {
                extras.push({ key: it, position: index });
            }
        });
        // console.log(`extras for board ${training.board.level}`, extras)
        while (extras.length > 0) {
            const positions = extras.map(it => it.position);
            const lastPosition = Math.max(...positions);
            const index = positions.indexOf(lastPosition);
            const lastExtra = extras[index];
            extras.splice(index, 1);
            const lastExtraContent = content.substring(lastExtra.position);
            data[`extra_${lastExtra.key}`] = lastExtraContent
                .replace(Formatter.formatTrainingExtraTag(lastExtra.key), "")
                .trim();
            content = content
                .substring(0, content.length - lastExtraContent.length)
                .trim();
        }
        data.content = content.trim();
        return data;
    }
    submit() {
        console.log(`Trainings to upsert: ${this.trainings.length}`);
        const objects = this.trainings.map(it => {
            const contentData = this.createContent(it);
            const input = {
                day: it.day,
                week: it.week,
                year: it.year,
                board_id: it.board.id,
                ...contentData
            };
            return input;
        });
        const currentWeek = this.currentWeek;
        const currentYear = this.currentYear;
        const trainingsQuery = require("@/apollo/queries/programming.graphql");
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: require("@/apollo/mutations/insertOrUpdateTrainings.graphql"),
                variables: {
                    objects
                },
                refetchQueries: [
                    {
                        query: trainingsQuery,
                        variables: { week: currentWeek, year: currentYear }
                    }
                ],
                awaitRefetchQueries: true
            },
            onTask: async (task) => {
                this.submitTask = task;
                if (this.submitTask.isSuccessful) {
                    this.unsavedChanges = false;
                    await trainingService.updateTrainingsByDate();
                }
            }
        });
    }
    copyFromHistory() {
        if (this.weekFromHistory == null) {
            return;
        }
        this.fetchTrainingsFromHistory(this.weekFromHistory);
    }
    fetchBoards() {
        this.subscribeQuery({
            tag: "boards",
            options: {
                query: require("@/apollo/queries/allBoards.graphql"),
                variables: { orderByLevel: Order_By.Desc }
            },
            onTask: task => {
                this.boardsTask = task;
                if (task.isSuccessful) {
                    this.allBoardsQuery = task.data;
                    this.updateTrainings(this.currentWeek, this.currentYear);
                }
            }
        });
    }
    fetchHistoryList() {
        this.weeksFromHistory = [{
                value: null,
                text: 'Select programming from history'
            }];
        this.subscribeQuery({
            tag: "historyList",
            options: {
                query: require("@/apollo/queries/historyList.graphql"),
            },
            onTask: task => {
                // this.boardsTask = task;
                if (task.isSuccessful) {
                    const data = task.data.training_by_week.map((it) => {
                        return {
                            value: this.weekTag(it.week, it.year),
                            text: `${it.year} - Semaine ${it.week}`,
                        };
                    });
                    this.weeksFromHistory.push(...data);
                }
            }
        });
    }
    fetchTrainingsFromHistory(weekFromHistory) {
        console.log(`Fetch trainings from history for week ${weekFromHistory}`);
        const currentWeek = this.currentWeek;
        const currentYear = this.currentYear;
        this.subscribeQuery({
            tag: `trainings-from-history`,
            options: {
                query: require("@/apollo/queries/programming.graphql"),
                variables: { week: weekFromHistory.split("-")[0], year: weekFromHistory.split("-")[1] }
            },
            onTask: task => {
                this.copyFromHistoryTask = task;
                if (task.isSuccessful) {
                    const data = {
                        ...task.data,
                        training_by_week: task.data.training_by_week.map((it) => {
                            return {
                                ...it,
                                week: currentWeek,
                                year: currentYear,
                            };
                        })
                    };
                    this.trainingsQueries.set(this.weekTag(currentWeek, currentYear), data);
                    this.updateTrainings(currentWeek, currentYear);
                }
            }
        });
    }
    fetchTrainings() {
        // const dateRange = this.dateRangeTag(this.startDate, this.endDate)
        const weekTag = this.weekTag(this.currentWeek, this.currentYear);
        if (this.trainingsQueries.has(weekTag)) {
            if (this.trainings.filter(it => this.isSameWeek(it, this.currentWeek, this.currentYear)).length > 0) {
                console.log(`Trainings already loaded for week ${weekTag}`);
                this.updateTrainingsPerRows();
            }
            else {
                // Query completed but callback did not run
                this.updateTrainings(this.currentWeek, this.currentYear);
            }
            return;
        }
        console.log(`Fetch trainings for week ${weekTag}`);
        const currentWeek = this.currentWeek;
        const currentYear = this.currentYear;
        this.subscribeQuery({
            tag: `trainings`,
            options: {
                query: require("@/apollo/queries/programming.graphql"),
                variables: { week: currentWeek, year: currentYear }
            },
            onTask: task => {
                this.trainingsTask = task;
                if (task.isSuccessful) {
                    // console.log(task.data!.training)
                    this.trainingsQueries.set(weekTag, task.data);
                    this.updateTrainings(currentWeek, currentYear);
                }
            }
        });
    }
    updateTrainings(week, year) {
        const weekTag = this.weekTag(week, year);
        if (this.allBoardsQuery == null || !this.trainingsQueries.has(weekTag)) {
            console.log(`Cannot update trainings for week ${weekTag}, not ready yet`);
            return;
        }
        console.log(`Update trainings for week ${weekTag}`);
        _.remove(this.trainings, it => this.isSameWeek(it, week, year));
        const trainingsQuery = this.trainingsQueries.get(weekTag);
        for (let board of this.allBoardsQuery.board) {
            // const daysOff: Array<number> = StringUtils.isNotBlank(board.days_off) ? _.uniq(_.split(board.days_off, ',').map(it => Number(it)).filter(it => Number.isInteger(it))) : []
            // console.log(`Days off for board ${board.level}: ${daysOff}`)
            // let daysOffPush = 0
            for (let day of _.range(1, 8)) {
                // while (daysOff.indexOf(trainingDay + daysOffPush) >= 0 && trainingDay + daysOffPush < 8) {
                //   daysOffPush += 1
                // }
                //
                // const day = trainingDay + daysOffPush
                // if (day > 7) {
                //   break
                // }
                //
                // const date = addDays(startDate, day - 1)
                // console.log(`Training day ${trainingDay} is ${format(date, 'dddd')}`)
                let training;
                const existingTraining = trainingsQuery.training_by_week.find(it => it.board.id === board.id && it.day == day);
                if (existingTraining != undefined) {
                    training = new TrainingData(existingTraining.id, existingTraining.day, existingTraining.week, existingTraining.year, Formatter.formatTrainingContent(existingTraining), "", "", "", "", board);
                }
                else {
                    training = new TrainingData(-1, day, week, year, "", "", "", "", "", board);
                }
                this.trainings.push(training);
            }
        }
        console.log(`Update trainings for week ${weekTag} - done`);
        this.updateTrainingsPerRows();
    }
    updateTrainingsPerRows() {
        console.log(`UPDATE ROWS`);
        const trainings = this.trainings.filter(it => it.year == this.currentYear &&
            it.week == this.currentWeek &&
            it.day == this.day);
        trainings.sort((a, b) => b.board.level - a.board.level);
        console.log(`Trainings per row for week ${this.currentWeek}: ${trainings.length}`);
        const trainingsPerRow = new Array();
        for (const [index, training] of trainings.entries()) {
            if (index % 2 == 0) {
                trainingsPerRow.push([]);
            }
            trainingsPerRow[trainingsPerRow.length - 1].push(training);
        }
        this.trainingsPerRows = trainingsPerRow;
    }
    // private dateRangeTag(startDate: Date, endDate: Date): string {
    //   return `${getDate(startDate)}/${getMonth(startDate)} - ${getDate(endDate)}/${getMonth(endDate)}`
    // }
    weekTag(week, year) {
        return `${week}-${year}`;
    }
    isSameWeek(training, week, year) {
        return training.week == week && training.year == year;
    }
};
__decorate([
    Watch("$route.query", { immediate: true })
], Programming.prototype, "onUpdateQuery", null);
Programming = __decorate([
    Component({
        components: { ProgressButton, TemplateContent, ProgrammingBoard }
    })
], Programming);
export default Programming;
